import { getAppEnv } from 'core/utils/runtimeConfig';

export const CURRENT_SERVER = getAppEnv('REACT_APP_CURRENT_SERVER') || 'SMDEV'; // this will only for internal logic
export const SOOMUCH_BASE_URL = getAppEnv('REACT_APP_CURRENT_ORIGIN') || window.location.origin;
export const API_HOST = `${getAppEnv('REACT_APP_CURRENT_ORIGIN') || window.location.origin}/api/v1/`;

export const ENCRYPTION_KEY = "";